import { useAsyncPaginatedData } from "../../hooks/useAsyncPaginatedData";
import { listVerificationHistory } from "../../lib/claimsApi";

/** The signed-in person's past verifications, a page at a time, newest first. */
export function useAccountVerifications() {
  return useAsyncPaginatedData(listVerificationHistory, { pageSize: 20 });
}
